module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1038-480df00010e2fd271793174092337804.png";